import { createActions, createReducer } from "reduxsauce";
import { has, get } from "lodash";
import Immutable from "seamless-immutable";

export const { Types, Creators } = createActions({
  searchCustomer: ["keyword", "searchFields"],
  searchCustomerSucceeded: ["searchCustomerResult"],
  clearSearchCustomerResult: [],
  saveCustomer: ["customer"],
  selectCustomer: ["customer"],
  exportCustomer: ["filters", "locations"],
  exportCustomerSucceeded: [],
  saveIssue: ["text", "customerKey"],
  deleteIssue: ["issueKey", "customerKey"],
  //TODO: move showMessage, clearMessage, actionSucceeded to common module
  showMessage: ["message"],
  clearMessage: [],
  // A place holder action to call
  // when redux-observable successfully finish the input action (SAVE, DELETE, ...)
  actionSucceeded: []
});

/*
Initial State
 */
const initialState = Immutable({
  searchCustomerResult: null,
  selectedCustomer: null,
  exporting: false
});

/*
Reducer
 */
const onSearchCustomerSucceeded = (state = initialState, action) =>
  Immutable.merge(state, {
    searchCustomerResult: action.searchCustomerResult
  });
const onClearSearchCustomerResult = (state = initialState) =>
  Immutable.merge(state, {
    searchCustomerResult: null
  });
const onSelectCustomer = (state = initialState, action) =>
  Immutable.merge(state, {
    selectedCustomer: action.customer
  });
const onExportCustomer = (state = initialState, action) =>
  Immutable.merge(state, {
    exporting: true
  });
const onExportCustomerSucceeded = (state = initialState, action) =>
  Immutable.merge(state, {
    exporting: false
  });
const onShowMessage = (state = initialState, action) =>
  Immutable.merge(state, {
    message: action.message
  });
const onClearMessage = (state = initialState) =>
  Immutable.merge(state, {
    message: null
  });

export default createReducer(initialState, {
  [Types.SEARCH_CUSTOMER_SUCCEEDED]: onSearchCustomerSucceeded,
  [Types.CLEAR_SEARCH_CUSTOMER_RESULT]: onClearSearchCustomerResult,
  [Types.SELECT_CUSTOMER]: onSelectCustomer,
  [Types.EXPORT_CUSTOMER]: onExportCustomer,
  [Types.EXPORT_CUSTOMER_SUCCEEDED]: onExportCustomerSucceeded,
  [Types.SHOW_MESSAGE]: onShowMessage,
  [Types.CLEAR_MESSAGE]: onClearMessage
});

/*
Selectors
*/
export function getSearchResult(state) {
  return has(state, ["customer", "searchCustomerResult"])
    ? state.customer.searchCustomerResult
    : [];
}
export function getCustomer(state, customerId) {
  return get(state, ["data", "customers", customerId], null);
}
export function getMessage(state) {
  return has(state, ["customer", "message"]) ? state.customer.message : null;
}

export function getIssues(state, customerKey) {
  return has(state, ["data", "issues", customerKey])
    ? state.data.issues[customerKey]
    : {};
}
export function getExporting(state) {
  return get(state, ["customer", "exporting"], false);
}
//@TODO: move to a less specific module like common later
export function isAdmin(state) {
  if (
    has(state, ["login", "username"]) &&
    state.login.username &&
    has(state, ["data", "administrators"]) &&
    state.data.administrators.length > 0
  ) {
    if (state.data.administrators.indexOf(state.login.username) !== -1) {
      return true;
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/customer/reducer.js